// archiveFilter.js
export default function initArchiveFilter() {

    // GUARD FSR ARCHIVE
    if (document.querySelector('[data-fsr-archive]')) {
        if (window.console && console.info) {
            console.info('[FSR ArchiveFilter] disattivato: trovato data-fsr-archive.');
        }
        return;
    }

    const form = document.getElementById('archive-filter-form');
    if (!form) return;

// Recupera l'URL base dall'attributo action del form (l'URL dell'archivio)
    const baseArchiveUrl = form.getAttribute('action');

    // Funzione per raccogliere i dati dal form
   /* const getFormData = () => {
        const formData = new FormData(form);
        // Se l'URL contiene 'paged' o 'page', aggiungilo (se non già presente nel form)
        const urlParams = new URLSearchParams(window.location.search);
        let paged = urlParams.get('paged') || urlParams.get('page');
        if (paged) {
            // Se il form non ha un campo 'paged', lo inseriamo
            formData.set('paged', paged);
        }
        formData.append('action', 'filter_archive');
        return formData;
    };*/

    const getFormData = () => {
        const form = document.getElementById('archive-filter-form');
        const formData = new FormData(form);

        // 1️⃣ unisci i parametri della query string (es. ?area=climate)
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.forEach((value, key) => {
            if (!formData.has(key)) {
                formData.append(key, value);
            }
        });

        const path = window.location.pathname;

        // es. /tag/carbon-market/page/2/  → taxonomy = 'topics', term = 'carbon-market'
        // es. /category/energy/           → taxonomy = 'categories', term = 'energy'
        const tagMatch = path.match(/\/tag\/([^/]+)/);
        const catMatch = path.match(/\/category\/([^/]+)/);
        const taxMatch = path.match(/\/taxonomy\/([^/]+)\/([^/]+)/);

        if (tagMatch && !formData.has('topics')) {
            formData.append('topics', tagMatch[1]);
        } else if (catMatch && !formData.has('categories')) {
            formData.append('categories', catMatch[1]);
        } else if (taxMatch) {
            const taxonomy = taxMatch[1];
            const term = taxMatch[2];
            if (!formData.has(taxonomy)) {
                formData.append(taxonomy, term);
            }
        }

        if (!formData.has('post_type') || !formData.get('post_type')) {
            formData.set('post_type', 'any');
        }

        formData.set('action', 'filter_archive');
        formData.append('nonce', FSR_AJAX.nonce);

        return formData;
    };

    // Funzione per aggiornare l'URL del browser usando il FormData passato
    const updateBrowserUrl = (fd) => {
        // Creiamo un URLSearchParams a partire dal FormData passato
        const formParams = new URLSearchParams(fd);
        // Rimuoviamo il parametro 'action'
        formParams.delete('action');

        // Costruiamo l'URL a partire dal baseArchiveUrl
        let newUrl = new URL(baseArchiveUrl, window.location.origin);

        // Se esiste il parametro 'paged', spostiamolo nel pathname
        if (formParams.has('paged')) {
            const paged = formParams.get('paged');
            formParams.delete('paged');
            let pathname = newUrl.pathname;
            if (!pathname.endsWith('/')) {
                pathname += '/';
            }
            newUrl.pathname = pathname + 'page/' + paged + '/';
        }

        // Se esistono altri parametri, li aggiungiamo come query string
        const qs = formParams.toString();
        newUrl.search = qs ? '?' + qs : '';

        // Aggiorna l'URL del browser
        window.history.pushState({}, '', newUrl.toString());

    };


    // Funzione per eseguire la chiamata AJAX e aggiornare i contenuti
    const ajaxUpdate = (formData) => {

        // Mostra lo skeleton prima di avviare la chiamata
        showSkeleton();

        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }

        fetch(FSR_AJAX.ajax, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {

                    setTimeout(() => {
                        // Aggiorna i container dei post e dei pills
                        const postsContainer = document.getElementById('archive-posts');
                        if (postsContainer) {
                            postsContainer.innerHTML = data.data.posts_html;
                        }
                        const pillsContainer = document.getElementById('archive-pills');
                        if (pillsContainer) {
                            pillsContainer.innerHTML = data.data.pills_html;
                        }
                        // Aggiorna anche l'URL nel browser
                        updateBrowserUrl();
                    }, 500);
                }
            })
            .catch(error => console.error('AJAX Error:', error));
    };

    // --- Gestione submit del form (evita il reload) ---
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        const formData = getFormData();
        ajaxUpdate(formData);
    });

    // --- Gestione change delle select ---
    const selects = form.querySelectorAll('select');
    selects.forEach(select => {
        select.addEventListener('change', () => {
            const formData = getFormData();
            ajaxUpdate(formData);
        });
    });

    // --- Gestione click sui link di paginazione ---
    /*document.addEventListener('click', (e) => {
        const pageLink = e.target.closest('.page-numbers');
        if (pageLink) {
            e.preventDefault();
            // Costruiamo un URL completo utilizzando window.location.origin
            const url = new URL(pageLink.href, window.location.origin);
            // Proviamo a leggere 'paged' oppure 'page'
            let paged = url.searchParams.get('paged') || url.searchParams.get('page');
            if (!paged) {
                // Se non ci sono parametri, prova a estrarre dal pathname (es. /page/2/)
                const match = url.pathname.match(/page\/(\d+)/);
                if (match) {
                    paged = match[1];
                }
            }
            const formData = getFormData();
            if (paged) {
                formData.set('paged', paged);
            }
            ajaxUpdate(formData);
        }
    });*/

    document.addEventListener('click', (e) => {
        const pageLink = e.target.closest('.Pagination__link');
        if (pageLink) {
            e.preventDefault();
            // Costruiamo un URL completo usando window.location.origin
            const url = new URL(pageLink.href, window.location.origin);
            // Proviamo a leggere 'paged' oppure 'page'
            let paged = url.searchParams.get('paged') || url.searchParams.get('page');
            if (!paged) {
                // Se non c'è, prova a estrarlo dal pathname, es. /people/page/2/
                const match = url.pathname.match(/page\/(\d+)\//);
                if (match) {
                    paged = match[1];
                }
            }
            // Recupera i dati attuali dal form (che contengono i filtri attivi)
            const formData = getFormData();
            if (paged) {
                formData.set('paged', paged);
            }
            for (let [key, value] of formData.entries()) {
                console.log(`${key}: ${value}`);
            }
            ajaxUpdate(formData);
        }
    });

    // --- Gestione click sui pills per rimuovere il filtro ---
    document.addEventListener('click', (e) => {
        const pill = e.target.closest('.filter-pill');
        if (pill) {
            e.preventDefault();
            const filterName = pill.dataset.filter;
            const input = form.querySelector(`[name="${filterName}"]`);
            if (input) {
                input.value = "";
            }
            const formData = getFormData();
            formData.delete(filterName);
            ajaxUpdate(formData);
        }
    });

    // Funzione per mostrare i placeholder skeleton
    const showSkeleton = () => {
        const postsContainer = document.getElementById('archive-posts');
        if (postsContainer) {
            // Calcola il numero di elementi Card__Horiz presenti attualmente
            const existingCards = postsContainer.querySelectorAll('.Card__Horiz');
            let numSkeletonCards = existingCards.length;
            // Se non ne trovi, usa un fallback (es. 12)
            if (numSkeletonCards === 0) {
                numSkeletonCards = 12;
            }
            let skeletonHTML = '';
            for (let i = 0; i < numSkeletonCards; i++) {
                skeletonHTML += `
        <div class="col-12 col-lg-6 ">
          <div class="Card__Horiz Card__Horiz__People mb-4">
            <p class="card-text placeholder-glow w-100 py-4 px-4">
              <span class="placeholder col-7"></span>
              <span class="placeholder col-4"></span>
              <span class="placeholder col-4"></span>
              <span class="placeholder col-6"></span>
              <span class="placeholder col-8"></span>
               <span class="placeholder col-4"></span>
            </p>
          </div>
        </div>
      `;
            }
            postsContainer.innerHTML = `<div class="row">${skeletonHTML}</div>`;
        }
    };


}